import { render } from "./ModalCambiarEstado.vue?vue&type=template&id=c0a8dc06"
import script from "./ModalCambiarEstado.vue?vue&type=script&lang=js"
export * from "./ModalCambiarEstado.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__